import React from 'react';
import { Typography } from '../Typography';
import clsx from 'clsx';

export interface MiniTitleWrapperProps {
  title: string;
  className?: string;
}

export const MiniTitleWrapper: React.FC<MiniTitleWrapperProps> = ({ title, className }: MiniTitleWrapperProps) => {
  return (
    <div className={clsx('bg-gray-100 p-1 px-6 w-fit mx-auto rounded-lg', className)}>
      <Typography transform="uppercase" color="gray">
        {title}
      </Typography>
    </div>
  );
};
